import Grid from '@mui/material/Grid2';
import { adminSettingsUtils } from 'utils/selectOptionsUtils';

import AcInput from 'components/AcInput/AcInput';

import AcCard from '../../../AcCard/AcCard';
import AcSelect from '../../../AcSelect/AcSelect';

import '../../../../style/forms.scss';
import '../../../Theme/style.scss';

export const QuantityFormat: React.FC<{
  title: string;
  quantityFormat: any;
  name: string;
  isFetching: boolean;
  touched: any;
  errors: any;
  handleChange: (e: any) => void;
  handleBlur: (e: any) => void;
}> = ({
  title,
  quantityFormat,
  name,
  isFetching,
  touched,
  errors,
  handleChange,
  handleBlur
}) => {
  return (
    <AcCard stackContainer={false} title={title}>
      <Grid container rowSpacing={2} columnSpacing={1.5}>
        <Grid size={6}>
          <AcSelect
            loading={isFetching}
            header={'Thousands separator'}
            name={`${name}.milSeparator`}
            value={quantityFormat.milSeparator}
            items={adminSettingsUtils.separatorOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched?.milSeparator && Boolean(errors?.milSeparator)}
          />
        </Grid>
        <Grid size={6}>
          <AcSelect
            loading={isFetching}
            header={'Decimal separator'}
            name={`${name}.fractionalSeparator`}
            value={quantityFormat.fractionalSeparator}
            items={adminSettingsUtils.separatorOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.fractionalSeparator &&
              Boolean(errors?.fractionalSeparator)
            }
          />
        </Grid>
        <Grid size={2}>
          <AcSelect
            loading={isFetching}
            header="Abbreviate thousands (K)"
            name={`${name}.thousandShorthand`}
            value={String(quantityFormat.thousandShorthand)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.thousandShorthand && Boolean(errors?.thousandShorthand)
            }
          />
        </Grid>
        <Grid size={2}>
          <AcSelect
            loading={isFetching}
            header="Abbreviate millions (M)"
            name={`${name}.millionShorthand`}
            value={String(quantityFormat.millionShorthand)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.millionShorthand && Boolean(errors?.millionShorthand)
            }
          />
        </Grid>
        <Grid size={2}>
          <AcSelect
            loading={isFetching}
            header="Abbreviate billions (B)"
            name={`${name}.billionShorthand`}
            value={String(quantityFormat.billionShorthand)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.billionShorthand && Boolean(errors?.billionShorthand)
            }
          />
        </Grid>
        <Grid size={2}>
          <AcSelect
            loading={isFetching}
            header="Abbreviate trillions (T)"
            name={`${name}.trillionShorthand`}
            value={String(quantityFormat.trillionShorthand)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.trillionShorthand && Boolean(errors?.trillionShorthand)
            }
          />
        </Grid>
        <Grid size={2}>
          <AcSelect
            loading={isFetching}
            header="Abbreviate quadrillions (Q)"
            name={`${name}.quadrillionShorthand`}
            value={String(quantityFormat.quadrillionShorthand)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.quadrillionShorthand &&
              Boolean(errors?.quadrillionShorthand)
            }
          />
        </Grid>
        <Grid size={2}>
          <AcSelect
            loading={isFetching}
            header="Abbreviate quintillions (Qi)"
            name={`${name}.quintillionShorthand`}
            value={String(quantityFormat.quintillionShorthand)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.quintillionShorthand &&
              Boolean(errors?.quintillionShorthand)
            }
          />
        </Grid>
        <Grid size={6}>
          <AcSelect
            loading={isFetching}
            header="Digits based abbreviation"
            name={`${name}.digitsBasedAbbreviation`}
            value={String(quantityFormat.digitsBasedAbbreviation)}
            items={adminSettingsUtils.trueFalseOptions}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.digitsBasedAbbreviation &&
              Boolean(errors?.digitsBasedAbbreviation)
            }
          />
        </Grid>
        <Grid size={6}>
          <AcInput
            type="number"
            header="Max digits without shorthand"
            name={`${name}.maxDigitsWithoutShorthand`}
            value={String(quantityFormat.maxDigitsWithoutShorthand)}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched?.maxDigitsWithoutShorthand &&
              Boolean(errors?.maxDigitsWithoutShorthand)
            }
            helperText={
              touched?.maxDigitsWithoutShorthand &&
              errors?.maxDigitsWithoutShorthand
                ? errors.maxDigitsWithoutShorthand.toString()
                : ''
            }
          />
        </Grid>
      </Grid>
    </AcCard>
  );
};
